import { track } from '@core/tracking';
var trackLogout = function trackLogout() {
    track('logout');
};
export var AuthenticationTracking = {
    trackLogout: trackLogout
};

//# sourceMappingURL=AuthenticationTracking.js.map